export default "__VITE_ASSET__mCp3IUQo__"